/**
 * Compute the percentage of a value in a total
 * @param value
 * @param total
 * @param decimalCount
 */
export const computePercentage = (
  value: number,
  total: number,
  decimalCount: number = 0,
): number => {
  if (total === 0) return 100;

  return parseFloat(((value / total) * 100).toFixed(decimalCount));
};
